export default "__VITE_ASSET__nRpAQn4Mxa1sF7hwhg4BmQ__"